
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/genres/[slug]",
      function () {
        return require("private-next-pages/genres/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/genres/[slug]"])
      });
    }
  